import React from "react";
import LoginIndex from "./LoginIndex";
// import logo from './logo.svg';
// import './App.css';

function App() {
  return (
    <div className="App">
      <LoginIndex />
    </div>
  );
}

export default App;
